import { CombinedGraphQLErrors } from "@apollo/client";

import rethrowIfNotAborted from "apollo/rethrowIfNotAborted";

const rethrowIfNotHandledVersionError = (error: Error) => {
  if (CombinedGraphQLErrors.is(error)) return;
  rethrowIfNotAborted(error);
};

export default rethrowIfNotHandledVersionError;
